import { isToday } from 'date-fns'
import { useGetClientQuery } from 'shared/store'

/**
 * Checks if the SMS limit for the current day has been exceeded
 * @returns boolean
 */
export const useHasSMSLimitExceeded = () => {
    const { data: client } = useGetClientQuery()

    const currentDailySMS = client?.limits?.current_daily_sms || 0
    const dailySMSLimit = client?.limits?.daily_sms

    // If no limit is set, we assume the limit is not exceeded
    if (!dailySMSLimit) return false

    // If the last update to limits was not today, the daily SMS hasn't been reset
    const lastUpdated = client.limits?.updated ? new Date(client.limits.updated * 1000) : new Date()
    if (!isToday(lastUpdated)) return false

    return currentDailySMS >= dailySMSLimit
}
